module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "nowyu",
      "toolbar": "",
      "footer": ""
    }
  }, [_c('main-navigation'), _vm._v(" "), _c('main-toolbar'), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": "",
      "pl-5": "",
      "pr-5": ""
    }
  }, [_c('main-breadcrumb'), _vm._v(" "), _c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('main-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd4e45c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/MainLayout.vue
// module id = 335
// module chunks = 2